import React from 'react'
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

type IconProps = FontAwesomeIconProps

const Icon = (props: IconProps) => <FontAwesomeIcon {...props} />

export default Icon

export const CustomIcon = styled(Icon)<{ w?: string; h?: string }>`
  width: ${(props) => props.w ?? '1.25'}rem;
  height: ${(props) => props.h ?? '1.25'}rem;
`

CustomIcon.displayName = 'CustomIcon'
